export const FILE_TRANSFER_DIRECTIONS = ['Incoming', 'Outgoing'];
export const AS2_CONNECTION_TYPE = 'as2Connection';
export const SFTP_CONNECTION_TYPE = 'sftpConnection';
export const PARTNER_SFTP_CONNECTION_TYPE = 'partnerSftpConnection';
